<script setup lang="ts">
import type {Home} from '~/types/legacy'
import type {Populated} from '~/types/populated'

defineProps<{
  data: Exclude<Populated<Home>['ourWork'], undefined>
}>()

const lp = useLocalePath()
</script>

<template>
  <Container class="screen-content flex flex-col items-center px-0 py-16">
    <div class="mb-8 flex flex-col items-center justify-center text-center">
      <Heading as="h2" size="caption" class="mb-2">{{ data.title }}</Heading>

      <Heading as="h3" size="medium" class="mb-4 flex flex-col px-10 lg:px-0">
        {{ data.headline }}
      </Heading>

      <Paragraph size="medium" class="mb-8 max-w-lg px-8 lg:px-0">
        {{ data.body }}
      </Paragraph>

      <Action as="link" :to="lp('/projects')" intent="main" size="normal">
        {{ $t('home.projects.cta') }}
      </Action>
    </div>

    <ProjectsSlider :projects="data.projects ?? []" />
  </Container>
</template>
